import calculateFocalLength from 'helpers/calculations/calculateFocalLength'
import calculateHorizontalFieldOfView from 'helpers/calculations/calculateHorizontalFieldOfView'
import calculatePpf from 'helpers/calculations/calculatePpf'
import calculateAspectRatio from 'helpers/calculations/calculateAspectRatio'
import calculateVerticalFieldOfView from 'helpers/calculations/calculateVerticalFieldOfView'
import calculateVerticalAngleOfView from 'helpers/calculations/calculateVerticalAngleOfView'
import calculateDistanceToTarget from 'helpers/calculations/calculateDistanceToTarget'
import parseResolutions from 'helpers/parseResolutions'

/** Initial camera props that need to be calculated */
export default function calculatedCameraProps(camera) {
  const { imagerSize, distance, horizontalAngleOfView, model, tilt } = camera
  const horizontalResolution = model ? parseResolutions(model.resolution).horizontal : camera.horizontalResolution
  const verticalResolution = model ? parseResolutions(model.resolution).vertical : camera.verticalResolution

  const distanceToTarget = calculateDistanceToTarget({ distance, tilt })
  const horizontalFieldOfView = calculateHorizontalFieldOfView({ horizontalAngleOfView, distance: distanceToTarget })
  const aspectRatio = calculateAspectRatio({ horizontalResolution, verticalResolution })

  return {
    ...camera,
    focalLength: calculateFocalLength({ imagerSize, horizontalAngleOfView }),
    ppf: calculatePpf({ horizontalResolution, horizontalFieldOfView, model, distance: distanceToTarget }),
    aspectRatio: calculateAspectRatio({ horizontalResolution, verticalResolution }),
    verticalFieldOfView: calculateVerticalFieldOfView({ aspectRatio, horizontalFieldOfView }),
    verticalAngleOfView: calculateVerticalAngleOfView({ aspectRatio, horizontalAngleOfView }),
    distanceToTarget,
    horizontalFieldOfView,
    horizontalResolution,
    verticalResolution
  }
}



// WEBPACK FOOTER //
// ./src/helpers/cameras/calculatedCameraProps.js